import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../context/LanguageContext';
import { SURAHS } from '../utils/quranData';
import { Surah } from '../types';
import { Card } from 'primereact/card';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';

function Surahs(): React.ReactElement {
  const { t } = useTranslation();
  useLanguage(); // Keep for RTL support
  const [filter, setFilter] = useState('');

  const filteredSurahs = SURAHS.filter(surah => 
    surah.nameAr.includes(filter) || 
    surah.nameEn.toLowerCase().includes(filter.toLowerCase()) ||
    surah.number.toString().includes(filter)
  );

  return (
    <div>
      <h1 className="text-2xl font-bold mb-4">{t('nav.surahs')}</h1>

      <Card>
        <div className="mb-4">
          <IconField iconPosition="left" className="w-full">
              <InputIcon className="pi pi-search"> </InputIcon>
              <InputText
                value={filter}
                onChange={(e) => setFilter(e.target.value)}
                placeholder={t('common.search')}
                className="w-full"
              />
          </IconField>
        </div>

        <DataTable 
          value={filteredSurahs} 
          responsiveLayout="scroll"
          paginator
          rows={20}
          className="p-datatable-sm"
        >
          <Column 
            field="number" 
            header="#" 
            sortable
            style={{ width: '60px' }}
          />
          <Column 
            header={t('surah.name')}
            body={(row: Surah) => (
              <div>
                <div className="arabic-text text-lg">{row.nameAr}</div>
                <div className="text-sm text-color-secondary">{row.nameEn}</div>
              </div>
            )}
          />
          <Column 
            header={t('surah.pages')}
            body={(row: Surah) => (
              <span>
                {row.startPage} - {row.endPage}
                <span className="text-color-secondary ml-2">
                  ({row.endPage - row.startPage + 1})
                </span>
              </span>
            )}
          />
        </DataTable>
      </Card>
    </div>
  );
}

export default Surahs;
